import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Icon from "../../Icon/index";
import Link from "../../Link/index";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var Accordion = /*#__PURE__*/function (_React$Component) {
  _inherits(Accordion, _React$Component);
  var _super = _createSuper(Accordion);
  function Accordion(props) {
    var _this;
    _classCallCheck(this, Accordion);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleExpandClick", function () {
      var children = _this.props.children;
      var childrenLength = React.Children.count(children);
      if (_this.allGroupsOpened()) {
        _this.setState({
          activeGroups: []
        });
        return;
      }
      var newActiveGroups = Array.from({
        length: childrenLength
      }, function (v, k) {
        return k;
      });
      _this.setState({
        activeGroups: newActiveGroups
      });
    });
    _defineProperty(_assertThisInitialized(_this), "allGroupsOpened", function () {
      var children = _this.props.children;
      var activeGroups = _this.state.activeGroups;
      var childrenLength = React.Children.count(children);
      return activeGroups.length === childrenLength;
    });
    _this.state = {
      activeGroups: props.activeGroups || []
    };
    return _this;
  }
  _createClass(Accordion, [{
    key: "toggleGroup",
    value: function toggleGroup(groupIndex) {
      this.setState(function (prevActiveGroups) {
        var _prevActiveGroups$act;
        var activeGroups = prevActiveGroups === null || prevActiveGroups === void 0 ? void 0 : (_prevActiveGroups$act = prevActiveGroups.activeGroups) === null || _prevActiveGroups$act === void 0 ? void 0 : _prevActiveGroups$act.slice();
        var index = activeGroups.indexOf(groupIndex);
        if (index !== -1) {
          activeGroups.splice(index, 1);
        } else {
          activeGroups.push(groupIndex);
        }
        return {
          activeGroups: activeGroups
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        mobile = _this$props.mobile,
        className = _this$props.className,
        showExpandAll = _this$props.showExpandAll;
      var activeGroups = this.state.activeGroups;
      var children = React.Children.toArray(this.props.children);
      var accordionGroups = React.Children.map(children, function (item, index) {
        var active = activeGroups.indexOf(index) !== -1 && item.props.children;
        var handleClick = function handleClick() {
          return _this2.toggleGroup(index);
        };
        var groupClasses = cx(className, 'accordionGroup', {
          mobile: mobile
        });
        return /*#__PURE__*/React.createElement("div", {
          className: groupClasses,
          "data-t-id": "Accordion-deprecated"
        }, /*#__PURE__*/React.createElement("div", {
          className: cx({
            accordionHeader: true,
            noChildren: !item.props.children,
            active: active
          }),
          onClick: handleClick
        }, item.props.href ? /*#__PURE__*/React.createElement("a", {
          className: cx('link'),
          href: item.props.href
        }, item.props.title) : /*#__PURE__*/React.createElement("div", {
          className: cx('title', 'noContent')
        }, /*#__PURE__*/React.createElement("span", {
          className: cx('text')
        }, item.props.title)), item.props.children ? /*#__PURE__*/React.createElement(Icon, {
          className: cx('accordionHeaderArrow'),
          name: "dropdownArrow"
        }) : null), active ? /*#__PURE__*/React.createElement("div", {
          className: cx('accordionContent')
        }, item) : null);
      });
      var expandAllText = this.allGroupsOpened() ? 'Свернуть все' : 'Развернуть все';
      return /*#__PURE__*/React.createElement("div", {
        className: cx('accordion')
      }, !mobile && showExpandAll ? /*#__PURE__*/React.createElement(Link, {
        className: cx('expandAll', {
          expanded: this.allGroupsOpened()
        }),
        onClick: this.handleExpandClick
      }, expandAllText) : null, accordionGroups);
    }
  }]);
  return Accordion;
}(React.Component);
export { Accordion as default };
Accordion.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  mobile: PropTypes.bool,
  showExpandAll: PropTypes.bool,
  activeGroups: PropTypes.arrayOf(PropTypes.number)
} : {};